module.exports = __webpack_public_path__ + "media/4x3/lu-c858787c.svg";